import * as Sentry from '@sentry/react'
import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { Outlet } from 'react-router'

import { ErrorFallback } from '@/components/ErrorFallback'
import { RootLayout } from '@/shared/layouts/Default'
import { QueryClientProvider } from '@/shared/providers'

const MyApp = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider>
        <ErrorBoundary
          fallback={<ErrorFallback />}
          onError={(error) => Sentry.captureException(error)}
        >
          <RootLayout>
            <Outlet />
          </RootLayout>
        </ErrorBoundary>
      </QueryClientProvider>
    </HelmetProvider>
  )
}

export default MyApp
